
import { useEffect } from 'react';

interface SEOSchemaProps {
  schema: object;
}

export default function SEOSchema({ schema }: SEOSchemaProps) {
  useEffect(() => {
    const scriptId = 'seo-schema-jsonld';
    
    // Remove existing script if any
    const existingScript = document.getElementById(scriptId);
    if (existingScript) {
      existingScript.remove();
    }
    
    // Create new script element
    const script = document.createElement('script');
    script.id = scriptId;
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
    
    return () => {
      const scriptToRemove = document.getElementById(scriptId);
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, [schema]);
  
  return null;
}
